var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-564-232h2000V968H-564z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#E6E9EB",
    strokeWidth: 1.5,
    x: 0.75,
    y: 0.75,
    width: 302.5,
    height: 46.5,
    rx: 23.25
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5,
    transform: "translate(20.833 14.833)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.05 1.3v5.214a2.5 2.5 0 00.732 1.768l9.635 9.635a1.25 1.25 0 001.767 0l5.733-5.734a1.25 1.25 0 000-1.767L8.282.782A2.5 2.5 0 006.516.05H1.301C.61.05.05.61.05 1.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.426,
    cy: 4.425,
    r: 1.25
  }))))));
}
export default SvgTag;